import { render, staticRenderFns } from "./pro-facture.html?vue&type=template&id=4ef8b27c&scoped=true&external"
import script from "./pro-facture.js?vue&type=script&lang=js&external"
export * from "./pro-facture.js?vue&type=script&lang=js&external"
import style0 from "./pro-facture.scss?vue&type=style&index=0&id=4ef8b27c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef8b27c",
  null
  
)

export default component.exports